import { AppDate } from '../envTypes';

import { ModelBase } from './base';
import { BasicProfile } from './profile';
import { ModerationStatus } from './moderation';

export interface PopStoreThemeTemplateType {
  id: string;
  slug: string;
  value: string;
}

export enum PopStoreThemeTemplateAccessType {
  Free = 'free',
  Purchase = 'purchase',
  Subscription = 'subscription',
}

export type PopStoreThemeAvailability =
  | { type: PopStoreThemeTemplateAccessType.Free; id: string }
  | {
      type: PopStoreThemeTemplateAccessType.Purchase;
      id: string;
      price: number;
    }
  | {
      type: PopStoreThemeTemplateAccessType.Subscription;
      id: string;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      level: any /*not decided yet*/;
    };

export enum PopStoreThemeTemplateStyle {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum SearchPopStoreThemeTemplatePurpose {
  MANAGE = 'manage',
  APPLY = 'apply',
}

// /popStoreThemeTemplates/{themeId}
export interface PopStoreThemeTemplate extends ModelBase {
  name: string;
  style: PopStoreThemeTemplateStyle;
  type: PopStoreThemeTemplateType;
  thumbnailUrl?: string;

  subscriptionLevel: PopStoreThemeAvailability;

  privacy: boolean;
  // specify which creators can use this theme
  creatorIds?: string[];

  createdAt: AppDate;
  createdByProfile?: BasicProfile;
  createdByUserId: string;

  moderationStatus?: ModerationStatus;
  moderatedAt?: AppDate;
  moderatorProfile?: BasicProfile;
  moderatorUserId?: string;
  theme: string;
  position?: number;
}
